export enum LastTenTab {
  OpenQuotes = 0,
  LNOpenOrders = 1,
  LNSubmittedOrders = 2
}
